(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-review-videos-shop-buy-box]';
  var INITIALIZED_ATTR = 'data-rvshop-initialized';

  function initAllReviewVideoShopSections(context) {
    var scope = context || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);

    sections.forEach(function (section) {
      initReviewVideoShopSection(section);
    });
  }

  function initReviewVideoShopSection(section) {
    if (!section || section.getAttribute(INITIALIZED_ATTR) === 'true') return;

    section.setAttribute(INITIALIZED_ATTR, 'true');

    var config = getConfig(section);
    var state = {
      modalOpen: false,
      previewIndex: 0,
      previewTimer: null,
      carousel: null
    };

    initMainCarousel(section, config, state);
    initThumbnailVideos(section, config, state);
    initModalTriggers(section, config, state);
    initModalClose(section, state);
    initModalNavigation(section, config, state);
    initShopToggle(section, config);
    initAddToCart(section, config);
  }

  function getConfig(section) {
    var configScript = section.querySelector('[data-rvshop-config]');

    if (!configScript) {
      return {};
    }

    try {
      return JSON.parse(configScript.textContent || '{}');
    } catch (error) {
      console.error('[Review Videos Shop Box] Invalid config JSON:', error);
      return {};
    }
  }

  function initMainCarousel(section, config, state) {
    var carouselEl = section.querySelector('[data-rvshop-carousel]');

    if (!carouselEl) return;

    if (typeof window.Splide === 'undefined') {
      console.warn('[Review Videos Shop Box] Splide is not loaded.');
      return;
    }

    state.carousel = new window.Splide(carouselEl, {
      type: 'loop',
      perPage: positiveInteger(config.desktopPerPage, 5),
      gap: '1rem',
      arrows: true,
      pagination: false,
      breakpoints: {
        1200: {
          perPage: positiveInteger(config.tabletPerPage, 3)
        },
        749: {
          perPage: positiveInteger(config.mobilePerPage, 2)
        }
      }
    });

    state.carousel.on('move', function () {
      state.modalOpen = true;
    });

    state.carousel.on('moved', function () {
      state.modalOpen = false;
    });

    state.carousel.mount();
  }

  function initThumbnailVideos(section, config, state) {
    var thumbnails = Array.prototype.slice.call(section.querySelectorAll('[data-rvshop-thumb-video]'));

    thumbnails.forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'metadata');
      video.classList.remove('is-ready');

      video.addEventListener('loadeddata', function () {
        video.classList.add('is-ready');
      }, { once: true });

      try {
        video.load();
      } catch (error) {}

      try {
        var playPromise = video.play();

        if (playPromise && playPromise.then) {
          playPromise.then(function () {
            window.setTimeout(function () {
              try {
                video.pause();
                video.currentTime = 0;
              } catch (error) {}
            }, 60);
          }).catch(function () {});
        }
      } catch (error) {}
    });

    if (config.thumbnailPreviewEnabled && thumbnails.length > 0) {
      window.setTimeout(function () {
        cycleThumbnails(section, config, state);
      }, 600);
    }
  }

  function cycleThumbnails(section, config, state) {
    if (state.modalOpen) {
      state.previewTimer = window.setTimeout(function () {
        cycleThumbnails(section, config, state);
      }, 500);
      return;
    }

    var visibleThumbs = Array.prototype.slice.call(
      section.querySelectorAll('.splide__slide.is-visible [data-rvshop-thumb-video]')
    );

    if (visibleThumbs.length === 0) {
      state.previewTimer = window.setTimeout(function () {
        cycleThumbnails(section, config, state);
      }, 800);
      return;
    }

    visibleThumbs.forEach(function (video) {
      try {
        video.pause();
        video.currentTime = 0;
      } catch (error) {}
    });

    var currentVideo = visibleThumbs[state.previewIndex % visibleThumbs.length];

    ensureLoaded(currentVideo, function () {
      try {
        currentVideo.currentTime = 0;

        var playPromise = currentVideo.play();

        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {});
        }
      } catch (error) {}

      state.previewTimer = window.setTimeout(function () {
        try {
          currentVideo.pause();
          currentVideo.currentTime = 0;
        } catch (error) {}

        state.previewIndex += 1;
        cycleThumbnails(section, config, state);
      }, positiveInteger(config.thumbnailPreviewDuration, 2500));
    });
  }

  function ensureLoaded(video, callback) {
    if (!video) return;

    if (video.readyState >= 2) {
      callback();
      return;
    }

    var onReady = function () {
      video.removeEventListener('loadeddata', onReady);
      callback();
    };

    video.addEventListener('loadeddata', onReady, { once: true });

    try {
      video.load();
    } catch (error) {}
  }

  function initModalTriggers(section, config, state) {
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-rvshop-thumb-video]'));

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var modalId = thumb.getAttribute('data-rvshop-modal-id');
        var modal = modalId ? section.querySelector('#' + cssEscape(modalId)) : null;

        if (!modal) return;

        openModal(section, modal, config, state, thumb.currentSrc || thumb.getAttribute('src'));
      });
    });
  }

  function openModal(section, modal, config, state, sourceOverride) {
    pauseAllVideos(section);

    state.modalOpen = true;

    var modalVideo = modal.querySelector('[data-rvshop-modal-video]');
    var source = sourceOverride || modalVideo.getAttribute('data-src') || modalVideo.getAttribute('src');
    var shopToggle = modal.querySelector('[data-rvshop-shop-toggle]');

    modal.hidden = false;
    modal.classList.remove('is-shop-open');

    if (shopToggle) {
      shopToggle.classList.remove('is-visible');

      window.setTimeout(function () {
        if (!modal.hidden) {
          shopToggle.classList.add('is-visible');
        }
      }, positiveInteger(config.mobileShopDelay, 3000));
    }

    if (modalVideo && source) {
      try {
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.load();
        modalVideo.src = source;
        modalVideo.playsInline = true;
        modalVideo.setAttribute('playsinline', '');
        modalVideo.controls = true;
        modalVideo.muted = false;
        modalVideo.classList.remove('is-ready');
        modalVideo.load();
      } catch (error) {}

      var playNow = function () {
        modalVideo.classList.add('is-ready');

        try {
          var playPromise = modalVideo.play();

          if (playPromise && playPromise.catch) {
            playPromise.catch(function () {});
          }
        } catch (error) {}
      };

      if (modalVideo.readyState >= 2) {
        playNow();
      } else {
        modalVideo.addEventListener('loadeddata', playNow, { once: true });
      }
    }

    initProductGallery(modal);
    updateModalNavButtons(section, modal);
  }

  function closeModal(modal, state) {
    if (!modal) return;

    var modalVideo = modal.querySelector('[data-rvshop-modal-video]');

    if (modalVideo) {
      try {
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.load();
        modalVideo.classList.remove('is-ready');
      } catch (error) {}
    }

    modal.classList.remove('is-shop-open');
    modal.hidden = true;
    state.modalOpen = false;
  }

  function initModalClose(section, state) {
    var closeTriggers = Array.prototype.slice.call(section.querySelectorAll('[data-rvshop-modal-close]'));

    closeTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modal = trigger.closest('[data-rvshop-modal]');
        closeModal(modal, state);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      var openModalEl = section.querySelector('[data-rvshop-modal]:not([hidden])');

      if (openModalEl) {
        closeModal(openModalEl, state);
      }
    });
  }

  function initModalNavigation(section, config, state) {
    section.addEventListener('click', function (event) {
      var prevButton = event.target.closest('[data-rvshop-modal-prev]');
      var nextButton = event.target.closest('[data-rvshop-modal-next]');

      if (!prevButton && !nextButton) return;

      var currentModal = event.target.closest('[data-rvshop-modal]');

      if (!currentModal) return;

      var direction = prevButton ? -1 : 1;
      var nextModal = getRelativeModal(section, currentModal, direction);

      if (!nextModal) return;

      closeModal(currentModal, state);
      openModal(section, nextModal, config, state);
    });
  }

  function getRelativeModal(section, currentModal, direction) {
    var modals = Array.prototype.slice.call(section.querySelectorAll('[data-rvshop-modal]'));
    var currentIndex = modals.indexOf(currentModal);
    var nextIndex = currentIndex + direction;

    if (nextIndex < 0 || nextIndex >= modals.length) {
      return null;
    }

    return modals[nextIndex];
  }

  function updateModalNavButtons(section, modal) {
    var modals = Array.prototype.slice.call(section.querySelectorAll('[data-rvshop-modal]'));
    var currentIndex = modals.indexOf(modal);
    var prevButton = modal.querySelector('[data-rvshop-modal-prev]');
    var nextButton = modal.querySelector('[data-rvshop-modal-next]');

    if (prevButton) {
      prevButton.disabled = currentIndex <= 0;
    }

    if (nextButton) {
      nextButton.disabled = currentIndex >= modals.length - 1;
    }
  }

  function initShopToggle(section) {
    section.addEventListener('click', function (event) {
      var toggleButton = event.target.closest('[data-rvshop-shop-toggle]');
      var closeButton = event.target.closest('[data-rvshop-shop-close]');

      if (!toggleButton && !closeButton) return;

      var modal = event.target.closest('[data-rvshop-modal]');

      if (!modal) return;

      if (toggleButton) {
        modal.classList.toggle('is-shop-open');
      }

      if (closeButton) {
        modal.classList.remove('is-shop-open');
      }
    });
  }

  function initProductGallery(modal) {
    var gallery = modal.querySelector('[data-rvshop-product-gallery]');

    if (!gallery || gallery.getAttribute('data-rvshop-gallery-initialized') === 'true') return;

    if (typeof window.Splide === 'undefined') return;

    gallery.setAttribute('data-rvshop-gallery-initialized', 'true');

    var splide = new window.Splide(gallery, {
      type: 'slide',
      perPage: 1,
      arrows: true,
      pagination: false
    });

    splide.on('mounted move moved', function () {
      updateProductGalleryArrows(splide);
    });

    splide.mount();
    updateProductGalleryArrows(splide);
  }

  function updateProductGalleryArrows(splide) {
    if (!splide || !splide.root) return;

    var prev = splide.root.querySelector('.splide__arrow--prev');
    var next = splide.root.querySelector('.splide__arrow--next');
    var end = splide.Components.Controller.getEnd();

    if (prev) {
      prev.style.opacity = splide.index === 0 ? '0.2' : '';
      prev.style.pointerEvents = splide.index === 0 ? 'none' : '';
    }

    if (next) {
      next.style.opacity = splide.index === end ? '0.2' : '';
      next.style.pointerEvents = splide.index === end ? 'none' : '';
    }
  }

  function initAddToCart(section, config) {
    section.addEventListener('click', function (event) {
      var button = event.target.closest('[data-rvshop-atc]');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      handleAddToCart(section, config, button);
    });
  }

  function handleAddToCart(section, config, clickedButton) {
    var status = section.querySelector('[data-rvshop-status]');
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-rvshop-atc]'));
    var originalButtonLabels = buttons.map(function (button) {
      return button.innerHTML;
    });

    if (!config.variantId) {
      setStatus(status, 'Please select a product or enter a variant ID in the section settings.');
      return;
    }

    pauseAllVideos(document);
    setStatus(status, '');
    setLoading(buttons, config.loadingText || 'Adding...');

    window.__skipAutoOpenDrawer = true;

    addOfferToCart(config)
      .then(function () {
        if (config.redirectTarget === 'stay') {
          setStatus(status, config.successText || 'Added to cart.');
          resetButtons(buttons, originalButtonLabels);
        }

        return redirectAfterAdd(config);
      })
      .catch(function (error) {
        console.error('[Review Videos Shop Box] Add to cart error:', error);
        setStatus(status, config.errorText || 'Something went wrong. Please try again.');
        resetButtons(buttons, originalButtonLabels);

        if (clickedButton) {
          clickedButton.focus();
        }
      });
  }

  function addOfferToCart(config) {
    var sequence = Promise.resolve();

    if (config.clearCartBeforeAdd) {
      sequence = sequence.then(clearCart);
    }

    return sequence
      .then(fetchCart)
      .then(function (cart) {
        var mainItem = buildMainItem(config);

        if (!mainItem) {
          throw new Error('No valid main item to add.');
        }

        return addItems([mainItem])
          .then(function () {
            var optionalItems = buildAdditionalItems(config, cart);
            return addOptionalItems(optionalItems);
          });
      })
      .then(function () {
        return updateCartAttributes(config);
      });
  }

  function buildMainItem(config) {
    var item = normalizeCartItem({
      id: config.variantId,
      quantity: config.quantity || 1,
      sellingPlanId: config.sellingPlanId
    });

    if (!item) return null;

    item.properties = {
      _source: config.cartAttributeSource || 'review-videos-shop-buy-box'
    };

    return item;
  }

  function buildAdditionalItems(config, cart) {
    var cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
    var additionalItems = Array.isArray(config.additionalItems) ? config.additionalItems : [];
    var seenKeys = {};
    var items = [];

    additionalItems.forEach(function (additionalItem) {
      var normalizedItem = normalizeCartItem(additionalItem);

      if (!normalizedItem) return;

      var key = String(normalizedItem.id) + '::' + String(normalizedItem.selling_plan || '');

      if (seenKeys[key]) {
        return;
      }

      if (additionalItem.dedupe && itemAlreadyInCart(cartItems, normalizedItem)) {
        return;
      }

      seenKeys[key] = true;
      items.push(normalizedItem);
    });

    return items;
  }

  function normalizeCartItem(item) {
    if (!item || !item.id) return null;

    var normalized = {
      id: String(item.id),
      quantity: positiveInteger(item.quantity, 1)
    };

    if (item.sellingPlanId) {
      normalized.selling_plan = String(item.sellingPlanId);
    }

    return normalized;
  }

  function itemAlreadyInCart(cartItems, newItem) {
    return cartItems.some(function (cartItem) {
      var sameVariant = String(cartItem.variant_id) === String(newItem.id);
      var cartSellingPlanId = cartItem.selling_plan_allocation &&
        cartItem.selling_plan_allocation.selling_plan &&
        cartItem.selling_plan_allocation.selling_plan.id;

      var newSellingPlanId = newItem.selling_plan || '';
      var sameSellingPlan = String(cartSellingPlanId || '') === String(newSellingPlanId || '');

      return sameVariant && sameSellingPlan;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to fetch cart.');
      }

      return response.json();
    });
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to clear cart.');
      }

      return response.json();
    });
  }

  function addItems(items) {
    if (!Array.isArray(items) || items.length === 0) {
      return Promise.resolve();
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (errorData) {
          throw new Error(errorData.description || errorData.message || 'Unable to add item to cart.');
        });
      }

      return response.json();
    });
  }

  function addOptionalItems(items) {
    if (!Array.isArray(items) || items.length === 0) {
      return Promise.resolve();
    }

    var sequence = Promise.resolve();

    items.forEach(function (item) {
      sequence = sequence.then(function () {
        return addItems([item]).catch(function (error) {
          console.warn('[Review Videos Shop Box] Optional cart item was skipped:', item.id, error);
          return null;
        });
      });
    });

    return sequence;
  }

  function updateCartAttributes(config) {
    if (!config.cartAttributeSource) {
      return Promise.resolve();
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          review_videos_shop_buy_box_source: config.cartAttributeSource
        }
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to update cart attributes.');
      }

      return response.json();
    });
  }

  function redirectAfterAdd(config) {
    var redirectTarget = config.redirectTarget || 'checkout';

    if (redirectTarget === 'stay') {
      window.dispatchEvent(new CustomEvent('review-videos-shop-buy-box:added', {
        detail: {
          sectionId: config.sectionId
        }
      }));

      return Promise.resolve();
    }

    var targetPath = redirectTarget === 'cart' ? '/cart' : '/checkout';
    var discountCodes = parseDiscountCodes(config.discountCodes);
    var redirectUrl = buildRedirectUrl(targetPath, discountCodes);

    window.location.assign(redirectUrl);
    return Promise.resolve();
  }

  function parseDiscountCodes(rawCodes) {
    if (!rawCodes || typeof rawCodes !== 'string') {
      return [];
    }

    return rawCodes
      .split(',')
      .map(function (code) {
        return code.trim();
      })
      .filter(Boolean);
  }

  function buildRedirectUrl(redirectPath, discountCodes) {
    if (!Array.isArray(discountCodes) || discountCodes.length === 0) {
      return redirectPath;
    }

    var encodedCodes = discountCodes
      .map(function (code) {
        return encodeURIComponent(code);
      })
      .join(',');

    var separator = redirectPath.indexOf('?') === -1 ? '?' : '&';

    return redirectPath + separator + 'discount=' + encodedCodes;
  }

  function setLoading(buttons, loadingText) {
    buttons.forEach(function (button) {
      button.classList.add('is-loading');
      button.disabled = true;

      if (loadingText) {
        button.innerHTML = '<span class="review-videos-shop-buy-box__cta-primary">' + escapeHtml(loadingText) + '</span>';
      }
    });
  }

  function resetButtons(buttons, originalButtonLabels) {
    buttons.forEach(function (button, index) {
      button.classList.remove('is-loading');
      button.disabled = false;

      if (originalButtonLabels[index]) {
        button.innerHTML = originalButtonLabels[index];
      }
    });
  }

  function setStatus(status, message) {
    if (!status) return;

    status.textContent = message || '';
  }

  function pauseAllVideos(scope) {
    var videoScope = scope || document;
    var videos = Array.prototype.slice.call(videoScope.querySelectorAll('video'));

    videos.forEach(function (video) {
      try {
        video.pause();
      } catch (error) {}
    });
  }

  function positiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);

    if (Number.isNaN(parsed) || parsed < 1) {
      return fallback;
    }

    return parsed;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/([ #;?%&,.+*~':"!^$[\]()=>|/@])/g, '\\$1');
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllReviewVideoShopSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllReviewVideoShopSections(event.target);
  });
})();